<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'DISCOUNT_GROUPS', url: '/admin/discount-groups' },
    { label: 'UPDATE_DISCOUNT_GROUP' }
  ]"
></breadcrumbs>

<page-header title="UPDATE_DISCOUNT_GROUP"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label">{{ 'NAME' | translate }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="name"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['name'])"
          [ngClass]="{ 'is-danger': hasError('name') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('name')">
        {{ getError('name') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="PERCENTAGE">{{
        'PERCENTAGE' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="percentage"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['percentage'])"
          [ngClass]="{ 'is-danger': hasError('percentage') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('percentage')">
        {{ getError('percentage') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3">
  <div class="control">
    <button
      (click)="onSubmit($event)"
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SUBMIT"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/discount-groups']"
      class="button is-link is-light"
      translationEditableDirective="translationEditableDirective="
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
